// Core imports
import * as React from 'react';
import LocaleFormating from 'src/translation/localeFormating';
import * as ReactDOM from 'react-dom';

import ItemModel from 'src/model/cartItem.model';
import UserModel from 'src/model/user.model';
import LocationModel from 'src/model/location.model';
import { IShippingMethod } from 'src/services/checkout/CheckoutService';
import CreditCardModel from 'src/model/creditCard.model';
import { env } from 'src/shared/env';

export interface ICheckoutCardPrintableProps {
  t: any;
  items: { [key: number]: ItemModel };
  userData: UserModel;
  deliverMethod: string;
  orderConfirmed: boolean;
  deliveryLocation: LocationModel;
  termsOfDelivery: string;
  PONumber: string;
  shippingMethod: IShippingMethod;
  paymentMethod: string;
  selectedCreditCard: CreditCardModel;
  closeWindow: () => void;
  confirmationNumber: number;
}

export interface ICheckoutCardPrintableState {
  container: HTMLDivElement | null;
}

class CheckoutCardPrintable extends React.Component<
  ICheckoutCardPrintableProps,
  ICheckoutCardPrintableState
> {
  private printWindow: Window;
  // private container: HTMLDivElement;

  constructor(props: ICheckoutCardPrintableProps) {
    super(props);

    this.state = {
      container: null
    };
  }

  public componentDidMount() {
    this.printWindow = window.open('', '', 'width=800,height=600');
    const document = this.printWindow.document;

    const container = document.createElement('div');
    document.body.appendChild(container);
    document.title = 'Order confirmation';
    this.setState({ container });
    // --------------
    const fun = () => {
      process.nextTick(() => {
        this.props.closeWindow();
      });
      this.printWindow.removeEventListener('beforeunload', fun);
    };

    this.printWindow.addEventListener('beforeunload', fun);
    setTimeout(() => {
      this.printWindow.print();
      this.printWindow.close();
    }, 600);
  }

  public componentWillUnmount() {
    const ua = navigator.userAgent;
    if (
      ua.indexOf('MSIE ') > -1 ||
      ua.indexOf('Edge') > -1 ||
      ua.indexOf('Trident/') > -1
    ) {
      location.reload();
    } else {
      this.printWindow.close();
    }
  }

  private getShipFrom = () => {
    const { t } = this.props;
    let currentState: string = '';
    let times: number = 0;
    for (const key in this.props.items) {
      if (this.props.items.hasOwnProperty(key)) {
        const state = `${
          this.props.items[key].shipsfrom.addressLine4
            ? `${this.props.items[
                key
              ].shipsfrom.addressLine4.toLocaleLowerCase()}, `
            : ''
        }${
          this.props.items[key].shipsfrom.stateCode
            ? `${this.props.items[key].shipsfrom.stateCode.toUpperCase()}`
            : ''
        }`;
        if (times === 0) {
          currentState = state;
        }
        if (state && state !== currentState) {
          return 'Different Locations';
        }
        times++;
      }
    }
    return currentState ? currentState : `${t('checkoutPage.noInfoAvailable')}`;
  };

  private formatPhoneNumber = (value:any) => {
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) { 
      return phoneNumber; 
    }
    if (phoneNumberLength < 7) {
      return `+1(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `+1(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  private renderAccountInfo = () => {
    const { name, mobileNumber, email } = this.props.userData;
    const { t } = this.props;
    return (
      <table>
        <thead>
          <tr style={{ fontWeight: 'bold' }}>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>
              {t('common.name')}{' '}
            </td>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>
              {t('common.email')}
            </td>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>
              {t('common.phone')}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>{name}</td>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>{localStorage.getItem("orderEmail")?localStorage.getItem("orderEmail"):email}</td>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>
              {localStorage.getItem("orderPhone")?this.formatPhoneNumber(localStorage.getItem("orderPhone")):this.formatPhoneNumber(mobileNumber)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  private renderShippingInfo = () => {
    const { t } = this.props;
    return (
      <div>
        <table>
          <thead>
            <tr style={{ fontWeight: 'bold' }}>
              <td style={{ padding: '0 8px', textAlign: 'left' }}>
                {t('checkoutPage.shippingTo')}
              </td>
              <td style={{ padding: '0 8px', textAlign: 'left' }}>
                {t('checkoutPage.shippingFrom')}
              </td>
              {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                this.props.deliverMethod !== 'Pick-Up' ? (
                  <td style={{ padding: '0 8px', textAlign: 'left' }}>
                    {t('checkoutPage.shippingMethod')}
                  </td>
                ) : (
                  ''
                )
              ) : (
                <td style={{ padding: '0 8px', textAlign: 'left' }}>
                  {t('checkoutPage.shippingMethod')}
                </td>
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style={{
                  padding: '0 8px',
                  textAlign: 'left',
                  textTransform: 'capitalize'
                }}
              >
                {this.props.deliveryLocation &&
                this.props.deliveryLocation.name !== ''
                  ? this.props.deliveryLocation.name
                  : 'N/A'}
              </td>
              <td
                style={{
                  padding: '0 8px',
                  textAlign: 'left',
                  textTransform: 'capitalize'
                }}
              >
                {this.getShipFrom()}
              </td>
              {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                this.props.deliverMethod !== 'Pick-Up' ? (
                  <td style={{ padding: '0 8px', textAlign: 'left' }}>
                    {this.props.shippingMethod.motdescription}
                  </td>
                ) : (
                  ''
                )
              ) : (
                <td style={{ padding: '0 8px', textAlign: 'left' }}>
                  {this.props.shippingMethod.motdescription}
                </td>
              )}
            </tr>
            <tr>
              <td
                style={{
                  padding: '0 8px',
                  textAlign: 'left',
                  textTransform: 'capitalize'
                }}
              >
                {this.props.deliveryLocation
                  ? `${
                      this.props.deliveryLocation.addressLine1
                        ? `${this.props.deliveryLocation.addressLine1.toLocaleLowerCase()}, `
                        : ''
                    }${
                      this.props.deliveryLocation.addressLine2
                        ? `${this.props.deliveryLocation.addressLine2.toLocaleLowerCase()}, `
                        : ''
                    }${
                      this.props.deliveryLocation.addressLine4
                        ? `${this.props.deliveryLocation.addressLine4.toLocaleLowerCase()}, `
                        : ''
                    }${
                      this.props.deliveryLocation.stateCode
                        ? `${this.props.deliveryLocation.stateCode} `
                        : ''
                    }${
                      this.props.deliveryLocation.postalCode
                        ? `${this.props.deliveryLocation.postalCode}`
                        : ''
                    }`
                  : 'N/A'}
              </td>
            </tr>
          </tbody>
        </table>
        <table style={{ margin: '32px 0px' }}>
          <thead>
            <tr style={{ fontWeight: 'bold' }}>
              <td style={{ padding: '0 8px', textAlign: 'left' }}>
                {t('myReturns.pONumber')}
              </td>
            </tr>
          </thead>
          <tbody>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>
              {this.props.PONumber}
            </td>
          </tbody>
        </table>
      </div>
    );
  };

  private renderPaymentMethod = () => {
    const { t } = this.props;
    return (
      <table>
        <thead>
          <tr style={{ fontWeight: 'bold' }}>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>{''}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: '0 8px', textAlign: 'left' }}>
              {this.props.paymentMethod === '001'
                ? `${t('checkoutPage.paidByAccount')}: #${
                    this.props.userData.accountId
                  }`
                : this.props.paymentMethod === '002' ||
                  this.props.paymentMethod === '004'
                ? this.props.selectedCreditCard
                  ? `${this.props.selectedCreditCard.type}: **** **** **** ${this.props.selectedCreditCard.number}`
                  : `${t('checkoutPage.paidByCreditCard')}`
                : this.props.paymentMethod === '003'
                ? 'Paid by Credit E-Check:'
                : null}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  private renderItemsOrder = () => {
    const { t } = this.props;
    return (
      <table
          style={{
            borderCollapse: 'collapse',
            tableLayout: 'fixed',
            width: '700px'
          }}
        >
        <thead>
          <tr style={{ fontWeight: 'bold' }}>
            <td
              style={{
                padding: '0 8px',
                textTransform: 'capitalize',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '15%'
              }}
            >
              {'Your Item'}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '8%'
              }}
            >
              {t('myOrders.qty')}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '18%'
              }}
            >
              {t('myFavourites.shipmentMarking')}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '14%'
              }}
            >
              {t('product.warrantyProvider')}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '14%'
              }}
            >
              {t('myFavourites.dispatch')}/<br/>{t('product.claims_plural')}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '14%'
              }}
            >
              {t('checkoutPage.shippingFrom')}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '8%'
              }}
            >
              {t('cartPage.unitPrice')}
            </td>
            <td
              style={{
                padding: '0 8px',
                textAlign: 'right',
                borderBottom: '1px solid #424242',
                width: '9%'
              }}
            >
              {t('myFavourites.itemTotal')}
            </td>
          </tr>
        </thead>
        <tbody>
          {Object.keys(this.props.items).map((item, index) => {
            const product = this.props.items[item];
            return (
              <tr key={index}
                style={{
                  wordWrap : 'break-word' 
                  }}
                >
                <td
                  style={{
                    padding: '0 8px',
                    textTransform: 'capitalize',
                    textAlign: 'left'
                  }}
                >
                  {product.name}
                </td>
                <td
                  style={{
                    padding: '0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.quantity}
                </td>
                <td
                  style={{
                    padding: '0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.shipmentMarking}
                </td>
                <td
                  style={{
                    padding: '0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.warrantyProvider}
                </td>
                <td
                  style={{
                    padding: '0 0 0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.claims}
                </td>
                <td
                  style={{
                    padding: '0 0 0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.shipsfrom.name}
                </td>
                <td
                  style={{
                    padding: '0 0 0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.unitPrice}
                </td>
                <td
                  style={{
                    padding: '0 0 0 8px',
                    textAlign: 'right'
                  }}
                >
                  {product.itemTotal}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  private getPrintableCheck = () => {
    const { t } = this.props;
    return (
      <div>
        <div className="address" style={{ fontFamily: 'Times New Roman' }}>
          <div style={{ float: 'right' }}>
            <p>
              {this.props.confirmationNumber
                ? `Confirmation #${this.props.confirmationNumber}`
                : ''}
            </p>
          </div>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              fontWeight: 'bold',
              margin: '130px 0 30px 0'
            }}
          >
            {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
              <React.Fragment>
                <span>Reliable Parts</span>
                <span>85 North Bend St</span>
                <span>Coquitlam, BC V3K 6N1</span>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <span>Reliable Parts</span>
                <span>P.O. Box 566268</span>
                <span>Dallas, Texas 75356</span>
              </React.Fragment>
            )}
          </p>
          {`Account: #${this.props.userData.accountId}`}
          <p
            style={{
              fontWeight: 'bold',
              margin: '0px 0 16px 0'
            }}
          >
            {t('checkoutPage.accountInfo')}
          </p>
          <div style={{ margin: '0 0 32px 0' }}>{this.renderAccountInfo()}</div>
          <p style={{ fontWeight: 'bold', margin: '0px 0 16px 0' }}>
            {t('checkoutPage.shippingInfo')}
          </p>
          <div style={{ margin: '0 0 32px 0' }}>
            {this.renderShippingInfo()}
          </div>
          <p style={{ fontWeight: 'bold', margin: '0px 0 16px 0' }}>
            {t('checkoutPage.paymentMethod')}
          </p>
          <div>{this.renderPaymentMethod()}</div>
        </div>
        <div style={{ margin: '24px 0 16px 0' }}>
          <div style={{ margin: '0 0 32px 0' }}>{this.renderItemsOrder()}</div>
        </div>
      </div>
    );
  };

  public render() {
    if (!this.state.container) {
      return null;
    }
    return ReactDOM.createPortal(
      this.getPrintableCheck(),
      this.state.container
    );
  }
}

export default CheckoutCardPrintable;
